import React, { ReactElement } from "react";
import GlobalProductDetails from "../../components/GlobalProducts/Details";
import Layout from "../../components/layout";

const GlobalProductDetailsPage = (): ReactElement => {
  return (
    <Layout>
      <GlobalProductDetails />
    </Layout>
  );
};

export default GlobalProductDetailsPage;
